import React, {useEffect, useState} from 'react';
import FunctionSidebarContainer from "../common/FunctionSidebar/FunctionSidebarContainer";
import Button from "@material-ui/core/Button";
import {NavLink, useHistory} from "react-router-dom";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import Box from "@material-ui/core/Box";
import {ReactSortable} from "react-sortablejs";
import Modal from "../common/Modals/Modal";
import noImg from "../../asset/noImage.jpg";
import Preloader from "../common/Preloader/Preloader";
import StickyBottomButton from "../common/StickyBottomButtonSave/StickyBottomButton";
import SavingSnackbar from "../common/SavingSnackbar/SavingSnackbar";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import AlertSavePage from "../common/AlertSavePage/AlertSavePage";
import {useMediaQuery} from "@material-ui/core";

const RenderRoomAddCard = ({objectId}) => {
    return (
        <Card className="card add-card add-object-room">
            <CardActionArea component={NavLink} to={`/lk/${objectId}/rooms/new`} className="d-flex w-100 h-100">
                <CardContent className={"add-object__icon"}>
                    <FontAwesomeIcon icon={"plus"}/>

                </CardContent>
                <CardContent>
                    <Typography className="add-object__text text-center" variant="h6">
                        Добавить номер
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    )
}

const RenderRoomsCard = ({objectId, id, name, active, image, confirmDeleteRoom, baseUrl}) => {

    return (
        <Card className="card card-object card-room h-100">
            <Button className="btn card-delete" onClick={() => confirmDeleteRoom(id)}>
                <FontAwesomeIcon icon={"trash"}/>
            </Button>
            <CardActionArea component={NavLink} to={`/lk/${objectId}/rooms/${id}`}>
                <CardMedia
                    component="img"
                    alt=""
                    height="120"
                    image={image.src ? `${baseUrl + image.src}` : noImg}

                    title=""
                />
                <CardContent className="card-body p-2">
                    <p className="card-text">
                        <span className="badge active">id: {id}</span>
                    </p>
                    <p className="card-title text-truncate">{name}</p>
                    <p className="card-text">
                        {active === "Y"
                            ? <span className="badge active">активен</span>
                            : <span className="badge deactive">неактивен</span>}

                    </p>
                </CardContent>
            </CardActionArea>
            <CardActionArea className="card-btn" component={NavLink} to={`/lk/${objectId}/rooms/${id}`}>
                <Box className="text-center">
                    Редактировать номер
                </Box>
            </CardActionArea>
            <CardActionArea className="card-btn" component={NavLink} to={`/lk/${objectId}/calendar/${id}`}>
                <Box className="text-center">
                    Редактировать цены
                </Box>
            </CardActionArea>

        </Card>
    )
}

const RenderRoomsList = ({confirmDeleteRoom, roomsList, setRoomsList, toggleUnsavedPage, baseUrl, objectId}) => {
    const mobileAgent = useMediaQuery('(max-width: 974px)') || window.matchMedia('(max-width: 974px)').matches;

    return (
        <div id="object-rooms" className="section">
            <ReactSortable animation={500} draggable=".card-sortable"
                           id="sortable"
                           disabled={mobileAgent}
                           onChange={() => toggleUnsavedPage(true)}
                           className="row cards-object row-cols-1 row-cols-md-3 row-cols-xl-4 row-cols-xxl-5 g-2 mb-3"
                           list={roomsList} setList={setRoomsList}>
                {roomsList.map((room, index) => (
                    <div key={index} className={`col ${index !== 0 && "card-sortable"}`}>
                        {index === 0
                            ? <RenderRoomAddCard objectId={objectId}/>
                            : <RenderRoomsCard {...room} confirmDeleteRoom={confirmDeleteRoom} baseUrl={baseUrl}
                                               objectId={objectId}/>
                        }
                    </div>
                ))}
            </ReactSortable>
        </div>
    )

}

//модалка удаления контакта
export const RenderModalRoomDelete = ({toggleShow, show, deletedRoomName, deleteRoom}) => {


    return (
        <Modal toggleShow={toggleShow} show={show}
               title={"Удаление номера:"}
               textBtnOk={"Удалить"} btnOkAction={deleteRoom}>
            <div className="col-sm-12 mb-1">
                <p>Вы уверены, что хотите удалить номер: <b>{deletedRoomName}</b>?</p>
            </div>
        </Modal>
    )
}


const ObjectRooms = (props) => {
    const {objectId, savePage, roomsListFromBd, baseUrl} = props

    const [unsavedPage, toggleUnsavedPage] = useState(false)
    const [roomsList, setRoomsList] = useState([{}])
    const [deletedRoom, setDeletedRoom] = useState();
    const [deletedRooms, setDeletedRooms] = useState([]);
    const [targetRedirectLink, setTargetRedirectLink] = useState(false)
    const history = useHistory()

    useEffect(() => {
        if (!!roomsListFromBd) {

            setRoomsList([{}, ...roomsListFromBd])
        }
    }, [roomsListFromBd])

    let [show, toggleModalShow] = useState(false);


    //открытие/закрытие модалок
    const toggleShow = () => {
        toggleModalShow(!show)
    };

    //подтверждение удаления номера
    const confirmDeleteRoom = (roomId) => {

        setDeletedRoom(roomsList.filter(item => item.id === roomId))
        toggleModalShow(!show)
    }

    //удаления номера
    const deleteRoom = () => {
        toggleUnsavedPage(true)
        let newDeletedRooms = deletedRooms
        newDeletedRooms.push(deletedRoom[0].id)

        setDeletedRooms(newDeletedRooms)
        setRoomsList(roomsList.filter(item => item.id !== deletedRoom[0].id))
        toggleModalShow(!show)
    }


    //сохранение страницы
    const savePageHandler = async () => {
        toggleUnsavedPage(false)
        // deletedRooms

        let rooms = roomsList.slice(1).map(item => item.id)

        let response = await savePage({object: objectId, section: "rooms", data: {rooms, deleted: deletedRooms}})

        if (response) {
            if (targetRedirectLink) {
                history.push(targetRedirectLink)
            }
        }

    }


    if (!roomsListFromBd) {
        return <Preloader loading={true} text={"Загружаем номера"}/>
    }
    return (
        <div className="main edit-object">
            <div className="container-fluid">
                <RenderRoomsList confirmDeleteRoom={confirmDeleteRoom}
                                 toggleUnsavedPage={toggleUnsavedPage}
                                 roomsList={roomsList}
                                 setRoomsList={setRoomsList}
                                 baseUrl={baseUrl}
                                 objectId={objectId}/>
            </div>

            {show && <RenderModalRoomDelete toggleShow={toggleShow}
                                            show={show}
                                            deletedRoomName={deletedRoom[0].name}
                                            deleteRoom={deleteRoom}/>}

            {unsavedPage && <StickyBottomButton action={savePageHandler}/>}
            <AlertSavePage unsavedPage={unsavedPage} btnOkAction={savePageHandler}
                           setTargetRedirectLink={setTargetRedirectLink} targetRedirectLink={targetRedirectLink}/>
            <FunctionSidebarContainer roomsWarning={true}/>
        </div>
    )
}


export default ObjectRooms